import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire « changer mon mot de passe » (`POST /Users/me/password`,
 * guide v4.1 §6.9). Trois champs : mot de passe actuel + nouveau + confirmation
 * (uniquement côté front, non envoyé au serveur).
 *
 * Factory (règle projet) : mémoïsée au niveau composant sur la langue courante.
 * La politique de mot de passe serveur (longueur, complexité) est appliquée
 * côté Keycloak — un refus 400 remonte via `getBackendErrorMessage`.
 */
export const createChangePasswordSchema = () =>
  z
    .object({
      currentPassword: z
        .string()
        .min(1, { message: t("requiredFieldError") }),
      newPassword: z
        .string()
        .min(8, { message: t("invalidFieldError") }),
      confirmPassword: z
        .string()
        .min(1, { message: t("requiredFieldError") }),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
      message: t("invalidFieldError"),
      path: ["confirmPassword"],
    })
    .refine((data) => data.newPassword !== data.currentPassword, {
      message: t("invalidFieldError"),
      path: ["newPassword"],
    });

export type ChangePasswordFormValues = z.infer<
  ReturnType<typeof createChangePasswordSchema>
>;
